import { AccountLimitAttributes } from "../attributes/account-limit-attributes";
import PricingGroup from "./PricingGroup";

class AccountLimit {
  id: number;
  min_credit: number;
  max_credit: number;
  max_transaction_volume: number;
  max_monthly_volume: number;

  pricing_group: PricingGroup;

  constructor(
    id: number,
    min_credit: number,
    max_credit: number,
    max_transaction_volume: number,
    max_monthly_volume: number,

    pricing_group: PricingGroup,
  ) {
    this.id = id;
    this.min_credit = min_credit;
    this.max_credit = max_credit;
    this.max_transaction_volume = max_transaction_volume;
    this.max_monthly_volume = max_monthly_volume;
    this.pricing_group = pricing_group;
  }

  static fromJson(
    json: AccountLimitAttributes
  ): AccountLimit | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new AccountLimit(
      json.id,
      json.min_credit,
      json.max_credit,
      json.max_transaction_volume,
      json.max_monthly_volume,
      json.pricing_group != null ? PricingGroup.fromJson(json.pricing_group) : null
    );
  }
}

export default AccountLimit;
